import React from "react";
import { useState, useEffect } from "react";
import { url } from "../../App";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
function useBulkUpload() {
    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const openView = (val) => setIsOpen(val);
    const [reportType, setreportType] = useState("ReportType");
    const [subsector, setSubsector] = useState("");
    const [sector, setSector] = useState("");
    const [industry, setIndustry] = useState("");
    const [businessNature, setBusinessNature] = useState("");
    const [title, setTitle] = useState("");
    const [gender, setGender] = useState("");
    const [maritalstatus, setmaritalstatus] = useState("");
    const [residencetype, setresidencetype] = useState("");
    const [education, seteducation] = useState("");
    const [professiontype, setprofessiontype] = useState("");
    const [CollectionBank, setCollectionBank] = useState("");
    const [companytype, setcompanytype] = useState("");
    const [SalaryMode, setSalaryMode] = useState("");
    const [loanBulkType, setloanBulkType] = useState("");
    const [loanAuthMode, setloanAuthMode] = useState("");
    const [loanEsignBy, setloanEsignBy] = useState("");
    const [loanAdvanceEmi, setloanAdvanceEmi] = useState("");
    const [loanStatus, setloanStatus] = useState("");
    const fileInputRef = React.useRef(null);
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    const navigate = useNavigate();
    function reset() {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setreportType("ReportType");
    }

    useEffect(() => {
        axios
            .post(url + "/user/getsingle", {
                token: token,
                email: email,
                useremail: email
            })
            .then((res) => {
                console.log(res);
                if (res.data.logout === true) {
                    toast.error(res.data.message, {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    setTimeout(() => {
                        navigate("/");
                    }, 3000);
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.message, {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
            });
    }, [token, email, navigate]);
    const handleChange = (e) => {
        // console.log(e.target.value);
        setreportType(e.target.value);
    };
    function insertDataIntoExcel(e) {
        if (reportType === "ReportType") {
            toast.error("Please Select Report Type", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
        } else if (reportType === "BorrowerBulkUpload") {
            // console.log(e.target.value);
            const workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.aoa_to_sheet([
                [
                    "Title",
                    "Gender",
                    "FirstName",
                    "MiddleName",
                    "LastName",
                    "DOB",
                    "MaritalStatus",
                    "ResidenceType",
                    "Education",
                    "ProfessionType",
                    "Pan",
                    "Aadhar",
                    "Mobile",
                    "Email",
                    "PermanentAddress",
                    "PermanentState",
                    "PermanentCity",
                    "PermanentPincode",
                    "PermanentLandmark",
                    "CurrentAddress",
                    "CurrentState",
                    "CurrentCity",
                    "CurrentPincode",
                    "CurrentLandmark",
                    "OfficialAddress",
                    "OfficialState",
                    "OfficialCity",
                    "OfficialPincode",
                    "OfficialLandmark",
                    "OfficeNumber",
                    "OfficeHrNumber",
                    "OfficeIndustry",
                    "OfficeSector",
                    "OfficeSubsector",
                    "NatureOfBusiness",
                    "EmployerName",
                    "Designation",
                    "BusinessName",
                    "Income",
                    "CurrentEmployerDuration",
                    "TotalWorkDuration",
                    "SalaryMode",
                    "CurrentSalary",
                    "PreviousSalary",
                    "ActiveLoans",
                    "ActiveEmiAmt",
                    "CreditLimit",
                    "CreditScore",
                    "YearsHeldNumber",
                    // "LoanPurpose",
                    "CollectionBankType",
                    "CollectionBankAccount",
                    "CollectionBankIfsc",
                    "CollectionBankBranch",
                    "CollectionBankName",
                    "CollectionBeneficiaryName",
                    "DisbursementBeneficiaryName",
                    "DisbursementBankAccount",
                    "DisbursementBankIfsc",
                    "DisbursementBankName",
                    "FriendReferenceName",
                    "FriendReferenceNumber",
                    "FamilyReferenceName",
                    "FamilyReferenceNumber",
                    "RequireTenure",
                    "RequireAmt",
                    "Comment",
                    "LoanOfficerAccess",
                    "SourceCode",
                    "CompanyCode",
                    "BranchCode",
                    "CreatedBy",
                    "CreatedDate",
                    "BusinessType",
                    "UniqueNo",
                    "Status",
                    "FatherName",
                    "NameOnPan",
                    "CompanyType",
                    "CreditStatus",
                    "KycId",
                    "DigiKycStatus",
                    "Age",
                    "UtilizedLimit",
                    "BankStatementPassword",
                ],
            ]);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelFile = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelFile], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "BorrowerBulkUploadSample.xlsx";
            link.click();
        } else if (reportType === "LoanBulkUpload") {
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([
                [
                    "LoanProductId",
                    "Type",
                    "MandateId",
                    "UMRN",
                    "CustStatus",
                    "BankStatus",
                    "ScheduleId",
                    "MandateFailReason",
                    "MandateLink",
                    "DisbursedmentReference",
                    "DisbursedmentDate",
                    "DisbursedmentNotify",
                    "AuthMode",
                    "NachNotify",
                    "EsignBy",
                    "EsignLink",
                    "BorrowerUniqueno",
                    "LoanproductInterestRate",
                    "PrincipalAmt",
                    "ReleaseDate",
                    "TenureStartDate",
                    "PreEmiInterest",
                    "EmiStartDate",
                    "EmiLastDate",
                    "Duration",
                    "EmiAmt",
                    "AdvanceEmiNumber",
                    "TrancheNumber",
                    // "TrancheArr",
                    // "TrancheGap",
                    "AvailInsurance",
                    "DisbursedAmt",
                    "Status",
                    "StatusTrail",
                    "EsignDocumentId",
                    "Gaurantors",
                    "LifeIns",
                    "PropertyIns",
                    "Comments",
                    "CreatedDate",
                    "CreatedBy",
                    "LoanId",
                    "PresentationStatus",
                    "LoanPurpose"
                ],
            ]);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelFile = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelFile], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "LoanBulkUploadSample.xlsx";
            link.click();
        } else if (reportType === "LeadBulkUpload") {
            const workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.aoa_to_sheet([
                [
                    "FirstName",
                    "MiddleName",
                    "LastName",
                    "Mobile",
                    "Email",
                    "Pan",
                    "DOB",
                    "BranchCode",
                    "CompanyCode",
                    "CreatedBy",
                    "Source",
                    "Status",
                    "CreditScore",
                    "CreatedDate",
                    "Id",
                    "LeadType"
                ],
            ]);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelFile = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelFile], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "LeadBulkUploadSample.xlsx";
            link.click();
        } else if (reportType === "CoapplicantBulkUpload") {
            const workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.aoa_to_sheet([
                [
                    "CoapplicantId",
                    "CoapplicantName",
                    "CoapplicantDOB",
                    "CoapplicantGender",
                    "CoapplicantMobile",
                    "CoapplicantEmail",
                    "CoapplicantMaritalStatus",
                    "CoapplicantEducation",
                    "CoapplicantResidenceType",
                    "CoapplicantResidenceAddress",
                    "CoapplicantPincode",
                    "CoapplicantState",
                    "CoapplicantCity",
                    "CoapplicantRelationship",
                    "CoapplicantFatherName",
                    "CoapplicantBorrowerUniqueno",
                    "CoapplicantLoanId",
                    "CoapplicantProfessionType",
                    "CoapplicantDesignation",
                    "CoapplicantBusinessName",
                    "CoapplicantOfficeAddress",
                    "CoapplicantTotalExp",
                    "CoapplicantMonthlyIncome",
                    "CoapplicantNatureOfBusiness",
                    "CoapplicantAadharno",
                    "CoapplicantPanno",
                ],
            ]);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelFile = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelFile], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "CoapplicantBulkUploadSample.xlsx";
            link.click();
        } else if (reportType === "CollateralBulkUpload") {
            const workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.aoa_to_sheet([
                [
                    "CollateralId",
                    "CollateralBorrowerUniqueNo",
                    "CollateralLoanId",
                    "CollateralType",
                    "CollateralAddress",
                    "CollateralState",
                    "CollateralCity",
                    "CollateralPincode",
                    "CollateralPropertyNumber",
                    "CollateralPropertyOwnerName",
                    "CollateralPropertyAreaMtr",
                    "CollateralPropertyAreaFt",
                ],
            ]);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelFile = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelFile], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "CollateralBulkUploadSample.xlsx";
            link.click();
        }
    }
    const formatExcelDate = (value) => {
        if (!value) return null;

        let jsDate;

        if (typeof value === "number") {
            // Convert Excel serial date to JS Date
            jsDate = new Date((value - 25569) * 86400 * 1000);
        } else if (typeof value === "string") {
            if (value.includes("-")) {
                // Parse dd-mm-yyyy string
                const [dd, mm, yyyy] = value.split("-");
                jsDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
            } else {
                // Try parsing other string formats
                jsDate = new Date(value);
            }
        } else {
            return null;
        }

        if (isNaN(jsDate.getTime())) return null;

        // Format date as dd-mm-yyyy string
        const day = String(jsDate.getDate()).padStart(2, "0");
        const month = String(jsDate.getMonth() + 1).padStart(2, "0"); // month is zero-based
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };
    useEffect(() => {

    }, [open, setOpen])
    const uploadFile = (e) => {
        const file = e?.target?.files?.[0];

        console.log("Selected file:", file);

        if (!file) {
            console.error("No file selected or invalid file input");
            setOpen(false);
            reset();
            toast.error("No file selected or invalid file input", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            return;
        }
        if (reportType === "LeadBulkUpload") {
            setOpen(true);
            // console.log(reportType);

            var reader, data, workbook, worksheet, sheetName;
            reader = new FileReader();
            var leadEntry = [];
            reader.onload = function (file) {
                try {
                    if (!file) {
                        console.error("No file selected or invalid file input");
                        setOpen(false);
                        reset()
                        toast.error("No file selected or invalid file input", {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                        return;
                    }
                    data = new Uint8Array(file.target.result);
                    workbook = XLSX.read(data, { type: "array" });
                    //console.log("workbook->", workbook);
                    sheetName = workbook.SheetNames[0];
                    worksheet = workbook.Sheets[sheetName];
                    leadEntry = XLSX.utils.sheet_to_json(worksheet);
                    console.log("leadEntry->", leadEntry);
                    const leadData = leadEntry.map((val) => {
                        return {
                            lead_firstname: val.FirstName,
                            lead_middlename: val.MiddleName,
                            lead_lastname: val.LastName,
                            lead_mobile: val.Mobile,
                            lead_email: val.Email,
                            lead_pan: val.Pan,
                            lead_dob: val.DOB,
                            lead_branchcode: val.BranchCode,
                            lead_companycode: val.CompanyCode,
                            created_by: val.CreatedBy,
                            lead_source: val.Source,
                            lead_status: val.Status,
                            lead_credit_score: val.CreditScore,
                            lead_created_date: val.CreatedDate,
                            lead_id: val.Id,
                            lead_type: val.LeadType

                        };
                    });
                    // console.log(leadData);
                    var leadArray = [];
                    for (var i = 0; i < leadData.length; i++) {
                        const dateString = formatExcelDate(leadData[i].lead_dob);
                        const createdDate = formatExcelDate(leadData[i].lead_created_date);


                        var leadObject = {
                            lead_firstname: leadData[i].lead_firstname,
                            lead_middlename: leadData[i].lead_middlename,
                            lead_lastname: leadData[i].lead_lastname,
                            lead_mobile: leadData[i].lead_mobile,
                            lead_email: leadData[i].lead_email,
                            lead_pan: leadData[i].lead_pan,
                            lead_dob: dateString,
                            lead_branchcode: leadData[i].lead_branchcode,
                            lead_companycode: leadData[i].lead_companycode,
                            created_by: leadData[i].created_by,
                            lead_source: leadData[i].lead_source,
                            lead_status: leadData[i].lead_status,
                            lead_credit_score: leadData[i].lead_credit_score,
                            lead_created_date: createdDate,
                            lead_id: leadData[i].lead_id,
                            lead_type: leadData[i].lead_type
                        };
                        leadArray.push(leadObject);
                    }
                    axios
                        .post(url + "/lead/bulkupload", {
                            array_data: leadArray,
                            token: token,
                            email: email,
                        })
                        .then((res) => {
                            // console.log(res);
                            if (res.data.auth === false) {
                                toast.error(res.data.message, {
                                    style: {
                                        background: "#fab6bb",
                                        color: "red",
                                        fontSize: "16px",
                                        borderRadius: "1rem",
                                        borderColor: "white"
                                    },
                                });
                                var report, wb;
                                if (res.data.errorMessage.length !== 0) {
                                    report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                    wb = XLSX.utils.book_new();
                                    XLSX.utils.book_append_sheet(wb, report, "Sample");
                                    XLSX.writeFile(wb, "LeadErrorFile.xlsx");
                                }

                                setOpen(false);
                                reset()

                            } else {
                                if (res.data.errorMessage.length !== 0) {
                                    report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                    wb = XLSX.utils.book_new();
                                    XLSX.utils.book_append_sheet(wb, report, "Sample");
                                    XLSX.writeFile(wb, "LeadErrorFile.xlsx");
                                }
                                toast.success(res.data.message);

                                setOpen(false);
                                reset()

                            }
                        })
                        .catch((err) => {
                            setOpen(false);
                            reset()
                            toast.error(err.message, {
                                style: {
                                    background: "#fab6bb",
                                    color: "red",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    borderColor: "white"
                                },
                            });
                        });
                } catch (err) {
                    setOpen(false);
                    reset()
                    toast.error(err.message, {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                }
            };
            reader.onerror = function (e) {
                setOpen(false);
                reset();
                toast.error(`Some thing went worng ! ${e.message}`, {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                }
                )
            }
            if (!e?.target?.files[0]) {
                console.error("No file selected or invalid file input");
                setOpen(false);
                reset();
                toast.error("No file selected or invalid file input", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
                return;
            }

            reader?.readAsArrayBuffer(e?.target?.files[0]);
        } else if (reportType === "BorrowerBulkUpload") {
            setOpen(true);
            //reset();
            // console.log(reportType);
                console.log("Selected file:", file);
            reader = new FileReader();
            var borrowerEntry = [];
            reader.onload = function (file) {
                if (!file) {
                    console.error("No file selected or invalid file input");
                    setOpen(false);
                    reset()
                    toast.error("No file selected or invalid file input", {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    return;
                }
                data = new Uint8Array(file.target.result);
                workbook = XLSX.read(data, { type: "array" });
                sheetName = workbook.SheetNames[0];
                worksheet = workbook.Sheets[sheetName];
                borrowerEntry = XLSX.utils.sheet_to_json(worksheet);
                // console.log(borrowerEntry);

                const borrowerData = borrowerEntry.map((val) => {
                    return {
                        borrower_title: val.Title,
                        borrower_gender: val.Gender,
                        borrower_firstname: val.FirstName,
                        borrower_middlename: val.MiddleName,
                        borrower_lastname: val.LastName,
                        borrower_dob: val.DOB,
                        borrower_maritalstatus: val.MaritalStatus,
                        borrower_residencetype: val.ResidenceType,
                        borrower_education: val.Education,
                        borrower_professiontype: val.ProfessionType,
                        borrower_panno: val.Pan,
                        borrower_aadharno: val.Aadhar,
                        borrower_mobile: val.Mobile,
                        borrower_email: val.Email,
                        borrower_permanent_address: val.PermanentAddress,
                        borrower_permanent_state: val.PermanentState,
                        borrower_permanent_city: val.PermanentCity,
                        borrower_permanent_pincode: val.PermanentPincode,
                        borrower_permanent_landmark: val.PermanentLandmark,
                        borrower_current_address: val.CurrentAddress,
                        borrower_current_state: val.CurrentState,
                        borrower_current_city: val.CurrentCity,
                        borrower_current_pincode: val.CurrentPincode,
                        borrower_current_landmark: val.CurrentLandmark,
                        borrower_official_address: val.OfficialAddress,
                        borrower_official_state: val.OfficialState,
                        borrower_official_city: val.OfficialCity,
                        borrower_official_pincode: val.OfficialPincode,
                        borrower_official_landmark: val.OfficialLandmark,
                        borrower_office_number: val.OfficeNumber,
                        borrower_office_hr_number: val.OfficeHrNumber,
                        borrower_office_industry: val.OfficeIndustry,
                        borrower_office_sector: val.OfficeSector,
                        borrower_office_subsector: val.OfficeSubsector,
                        borrower_nature_of_business: val.NatureOfBusiness,
                        borrower_employer_name: val.EmployerName,
                        borrower_designation: val.Designation,
                        borrower_business_name: val.BusinessName,
                        borrower_income: val.Income,
                        borrower_current_employer_duration: val.CurrentEmployerDuration,
                        borrower_total_work_duration: val.TotalWorkDuration,
                        borrower_salary_mode: val.SalaryMode,
                        borrower_current_salary: val.CurrentSalary,
                        borrower_previous_salary: val.PreviousSalary,
                        borrower_active_loans: val.ActiveLoans,
                        borrower_active_emi_amt: val.ActiveEmiAmt,
                        borrower_credit_limit: val.CreditLimit,
                        borrower_credit_score: val.CreditScore,
                        borrower_years_held_number: val.YearsHeldNumber,
                        // borrower_loan_purpose: val.LoanPurpose,
                        borrower_collection_bank_type: val.CollectionBankType,
                        borrower_collection_bank_account: val.CollectionBankAccount,
                        borrower_collection_bank_ifsc: val.CollectionBankIfsc,
                        borrower_collection_bank_branch: val.CollectionBankBranch,
                        borrower_collection_bank_name: val.CollectionBankName,
                        borrower_collection_beneficiary_name: val.CollectionBeneficiaryName,
                        borrower_disbursement_beneficiary_name:
                            val.DisbursementBeneficiaryName,
                        borrower_disbursement_bank_account: val.DisbursementBankAccount,
                        borrower_disbursement_bank_ifsc: val.DisbursementBankIfsc,
                        borrower_disbursement_bank_name: val.DisbursementBankName,
                        borrower_friend_reference_name: val.FriendReferenceName,
                        borrower_friend_reference_number: val.FriendReferenceNumber,
                        borrower_family_reference_name: val.FamilyReferenceName,
                        borrower_family_reference_number: val.FamilyReferenceNumber,
                        borrower_require_tenure: val.RequireTenure,
                        borrower_require_amt: val.RequireAmt,
                        borrower_comment: val.Comment,
                        borrower_loan_officer_access: val.LoanOfficerAccess,
                        borrower_sourcecode: val.SourceCode,
                        borrower_companycode: val.CompanyCode,
                        borrower_branchcode: val.BranchCode,
                        borrower_created_by: val.CreatedBy,
                        borrower_created_date: val.CreatedDate,
                        borrower_business_type: val.BusinessType,
                        borrower_password: val.Password,
                        borrower_uniqueno: val.UniqueNo,
                        borrower_status: val.Status,
                        borrower_process_status: val.ProcessStatus,
                        borrower_fathername: val.FatherName,
                        borrower_nameonpan: val.NameOnPan,
                        borrower_companytype: val.CompanyType,
                        borrower_credit_status: val.CreditStatus,
                        digio_kyc_id: val.KycId,
                        borrower_digikyc_status: val.DigikycStatus,
                        borrower_age: val.Age,
                        borrower_utilized_limit: val.UtilizedLimit,
                        borrower_bank_statement_password: val.BankStatementPassword,
                    };
                });
                 console.log("borrowerData-> ",borrowerData);

                var borrowerArray = [];
                for (var j = 0; j < borrowerData.length; j++) {
                    const borrowerDob = formatExcelDate(borrowerData[j].borrower_dob);
                    console.log("borrowerDob-> ",borrowerDob)
                    const splitBorrowerDob = borrowerDob ? borrowerDob?.split("-") : null;
                    if (borrowerDob) {
                        // console.log(`${splitBorrowerDob[2]}-${splitBorrowerDob[1]}-${splitBorrowerDob[0]}`);
                        var bd = `${splitBorrowerDob[2]}-${splitBorrowerDob[1]}-${splitBorrowerDob[0]}`;
                    } else {
                        bd = null;
                    }

                    const borrowerCreatedDate = formatExcelDate(borrowerData[j].borrower_created_date);
                    const splitBorrowerCreatedDate = borrowerCreatedDate
                        ? borrowerCreatedDate?.split("-")
                        : null;
                    if (borrowerCreatedDate) {
                        // console.log(`${splitBorrowerCreatedDate[2]}-${splitBorrowerCreatedDate[1]}-${splitBorrowerCreatedDate[0]}`);
                        var bcd = `${splitBorrowerCreatedDate[2]}-${splitBorrowerCreatedDate[1]}-${splitBorrowerCreatedDate[0]}`;
                    } else {
                        bcd = null;
                    }

                    var borrowerObject = {
                        borrower_title: borrowerData[j].borrower_title,
                        borrower_gender: borrowerData[j].borrower_gender,
                        borrower_firstname: borrowerData[j].borrower_firstname,
                        borrower_middlename: borrowerData[j].borrower_middlename,
                        borrower_lastname: borrowerData[j].borrower_lastname,
                        borrower_dob: bd,
                        borrower_maritalstatus: borrowerData[j].borrower_maritalstatus,
                        borrower_residencetype: borrowerData[j].borrower_residencetype,
                        borrower_education: borrowerData[j].borrower_education,
                        borrower_professiontype: borrowerData[j].borrower_professiontype,
                        borrower_panno: borrowerData[j].borrower_panno,
                        borrower_aadharno: borrowerData[j].borrower_aadharno,
                        borrower_mobile: borrowerData[j].borrower_mobile,
                        borrower_email: borrowerData[j].borrower_email,
                        borrower_permanent_address:
                            borrowerData[j].borrower_permanent_address,
                        borrower_permanent_state: borrowerData[j].borrower_permanent_state,
                        borrower_permanent_city: borrowerData[j].borrower_permanent_city,
                        borrower_permanent_pincode:
                            borrowerData[j].borrower_permanent_pincode,
                        borrower_permanent_landmark:
                            borrowerData[j].borrower_permanent_landmark,
                        borrower_current_address: borrowerData[j].borrower_current_address,
                        borrower_current_state: borrowerData[j].borrower_current_state,
                        borrower_current_city: borrowerData[j].borrower_current_city,
                        borrower_current_pincode: borrowerData[j].borrower_current_pincode,
                        borrower_current_landmark:
                            borrowerData[j].borrower_current_landmark,
                        borrower_official_address:
                            borrowerData[j].borrower_official_address,
                        borrower_official_state: borrowerData[j].borrower_official_state,
                        borrower_official_city: borrowerData[j].borrower_official_city,
                        borrower_official_pincode:
                            borrowerData[j].borrower_official_pincode,
                        borrower_official_landmark:
                            borrowerData[j].borrower_official_landmark,
                        borrower_office_number: borrowerData[j].borrower_office_number,
                        borrower_office_hr_number:
                            borrowerData[j].borrower_office_hr_number,
                        borrower_office_industry: borrowerData[j].borrower_office_industry,
                        borrower_office_sector: borrowerData[j].borrower_office_sector,
                        borrower_office_subsector:
                            borrowerData[j].borrower_office_subsector,
                        borrower_nature_of_business:
                            borrowerData[j].borrower_nature_of_business,
                        borrower_employer_name: borrowerData[j].borrower_employer_name,
                        borrower_designation: borrowerData[j].borrower_designation,
                        borrower_business_name: borrowerData[j].borrower_business_name,
                        borrower_income: borrowerData[j].borrower_income,
                        borrower_current_employer_duration:
                            borrowerData[j].borrower_current_employer_duration,
                        borrower_total_work_duration:
                            borrowerData[j].borrower_total_work_duration,
                        borrower_salary_mode: borrowerData[j].borrower_salary_mode,
                        borrower_current_salary: borrowerData[j].borrower_current_salary,
                        borrower_previous_salary: borrowerData[j].borrower_previous_salary,
                        borrower_active_loans: borrowerData[j].borrower_active_loans,
                        borrower_active_emi_amt: borrowerData[j].borrower_active_emi_amt,
                        borrower_credit_limit: borrowerData[j].borrower_credit_limit,
                        borrower_credit_score: borrowerData[j].borrower_credit_score,
                        borrower_years_held_number:
                            borrowerData[j].borrower_years_held_number,
                        // borrower_loan_purpose: borrowerData[j].borrower_loan_purpose,
                        borrower_collection_bank_type:
                            borrowerData[j].borrower_collection_bank_type,
                        borrower_collection_bank_account:
                            borrowerData[j].borrower_collection_bank_account,
                        borrower_collection_bank_ifsc:
                            borrowerData[j].borrower_collection_bank_ifsc,
                        borrower_collection_bank_branch:
                            borrowerData[j].borrower_collection_bank_branch,
                        borrower_collection_bank_name:
                            borrowerData[j].borrower_collection_bank_name,
                        borrower_collection_beneficiary_name:
                            borrowerData[j].borrower_collection_beneficiary_name,
                        borrower_disbursement_beneficiary_name:
                            borrowerData[j].borrower_disbursement_beneficiary_name,
                        borrower_disbursement_bank_account:
                            borrowerData[j].borrower_disbursement_bank_account,
                        borrower_disbursement_bank_ifsc:
                            borrowerData[j].borrower_disbursement_bank_ifsc,
                        borrower_disbursement_bank_name:
                            borrowerData[j].borrower_disbursement_bank_name,
                        borrower_friend_reference_name:
                            borrowerData[j].borrower_friend_reference_name,
                        borrower_friend_reference_number:
                            borrowerData[j].borrower_friend_reference_number,
                        borrower_family_reference_name:
                            borrowerData[j].borrower_family_reference_name,
                        borrower_family_reference_number:
                            borrowerData[j].borrower_family_reference_number,
                        borrower_require_tenure: borrowerData[j].borrower_require_tenure,
                        borrower_require_amt: borrowerData[j].borrower_require_amt,
                        borrower_comment: borrowerData[j].borrower_comment,
                        borrower_loan_officer_access:
                            borrowerData[j].borrower_loan_officer_access,
                        borrower_sourcecode: borrowerData[j].borrower_sourcecode,
                        borrower_companycode: borrowerData[j].borrower_companycode,
                        borrower_branchcode: borrowerData[j].borrower_branchcode,
                        borrower_created_by: borrowerData[j].borrower_created_by,
                        borrower_created_date: bcd,
                        borrower_business_type: borrowerData[j].borrower_business_type,
                        borrower_password: borrowerData[j].borrower_password,
                        borrower_uniqueno: borrowerData[j].borrower_uniqueno,
                        borrower_status: borrowerData[j].borrower_status,
                        borrower_process_status: borrowerData[j].borrower_process_status,
                        borrower_fathername: borrowerData[j].borrower_fathername,
                        borrower_nameonpan: borrowerData[j].borrower_nameonpan,
                        borrower_companytype: borrowerData[j].borrower_companytype,
                        borrower_credit_status: borrowerData[j].borrower_credit_status,
                        digio_kyc_id: borrowerData[j].digio_kyc_id,
                        borrower_digikyc_status: borrowerData[j].borrower_digikyc_status,
                        borrower_age: borrowerData[j].borrower_age,
                        borrower_utilized_limit: borrowerData[j].borrower_utilized_limit,
                        borrower_bank_statement_password:
                            borrowerData[j].borrower_bank_statement_password,
                    };
                    borrowerArray.push(borrowerObject);
                }
                 console.log("borrowerArray",borrowerArray);
                axios
                    .post(url + "/borrower/bulkupload", {
                        array_data: borrowerArray,
                        token: token,
                        email: email,
                    })
                    .then((res) => {
                        // console.log(res);
                        if (res.data.auth === false) {
                            toast.error(res.data.message, {
                                style: {
                                    background: "#fab6bb",
                                    color: "red",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    borderColor: "white"
                                },
                            });
                            var report, wb;
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "BorrowerErrorFile.xlsx");
                            }
                            setOpen(false);
                            reset()
                        } else {
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "BorrowerErrorFile.xlsx");
                            }
                            toast.success(res.data.message);
                            setOpen(false);
                            reset()

                        }
                    })
                    .catch((err) => {
                        setOpen(false);
                        reset();
                        // console.log(err);
                        toast.error(err.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                    });
            };
            console.log("checking file blob-> ", e?.target?.files[0])
            if (!e?.target?.files[0]) {
                console.error("No file selected or invalid file input");
                setOpen(false);
                reset();
                toast.error("No file selected or invalid file input", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
                return;
            }
            reader?.readAsArrayBuffer(e?.target?.files[0]);
        } else if (reportType === "LoanBulkUpload") {
            setOpen(true);
           // reset();
            // console.log(reportType);

            reader = new FileReader();
            var loanEntry = [];
            reader.onload = function (file) {
                if (!file) {
                    console.error("No file selected or invalid file input");
                    setOpen(false);
                    reset()
                    toast.error("No file selected or invalid file input", {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    return;
                }
                data = new Uint8Array(file.target.result);
                workbook = XLSX.read(data, { type: "array" });
                sheetName = workbook.SheetNames[0];
                worksheet = workbook.Sheets[sheetName];
                loanEntry = XLSX.utils.sheet_to_json(worksheet);
                // console.log(loanEntry);

                const loanData = loanEntry.map((val) => {
                    return {
                        loanproduct_id: val.LoanProductId,
                        loan_type: val.Type,
                        loan_mandate_id: val.MandateId,
                        loan_umrn: val.UMRN,
                        loan_cust_status: val.CustStatus,
                        loan_bank_status: val.BankStatus,
                        loan_schedule_id: val.ScheduleId,
                        loan_mandate_fail_reason: val.MandateFailReason,
                        loan_mandate_link: val.MandateLink,
                        loan_disbursedment_reference: val.DisbursedmentReference,
                        loan_disbursedment_date: val.DisbursedmentDate,
                        loan_disbursedment_notify: val.DisbursedmentNotify,
                        loan_auth_mode: val.AuthMode,
                        nach_notify: val.NachNotify,
                        loan_esign_by: val.EsignBy,
                        loan_esign_link: val.EsignLink,
                        borrower_uniqueno: val.BorrowerUniqueno,
                        loanproduct_interest_rate: val.LoanproductInterestRate,
                        loan_principal_amt: val.PrincipalAmt,
                        loan_release_date: val.ReleaseDate,
                        loan_tenure_start_date: val.TenureStartDate,
                        loan_pre_emi_interest: val.PreEmiInterest,
                        loan_emi_start_date: val.EmiStartDate,
                        loan_emi_last_date: val.EmiLastDate,
                        loan_duration: val.Duration,
                        loan_emi_amt: val.EmiAmt,
                        loan_advance_emi_number: val.AdvanceEmiNumber,
                        loan_tranche_number: val.TrancheNumber,
                        // loan_tranche_arr: val.TrancheArr,
                        // loan_tranche_gap: val.TrancheGap,
                        loan_avail_insurance: val.AvailInsurance,
                        loan_disbursed_amt: val.DisbursedAmt,
                        loan_status: val.Status,
                        loan_status_trail: val.StatusTrail,
                        loan_esign_document_id: val.EsignDocumentId,
                        loan_gaurantors: val.Gaurantors,
                        loan_life_ins: val.LifeIns,
                        loan_property_ins: val.PropertyIns,
                        loan_comments: val.Comments,
                        loan_companycode: val.CompanyCode,
                        loan_branchcode: val.BranchCode,
                        loan_sourcecode: val.SourceCode,
                        loan_created_date: val.CreatedDate,
                        created_by: val.CreatedBy,
                        loan_id: val.LoanId,
                        loan_presentation_status: val.PresentationStatus,
                        loan_purpose: val.LoanPurpose
                    };
                });
                console.log(loanData);

                var loanArray = [];
                for (var k = 0; k < loanData.length; k++) {
                    const loanDisbursedmentDate = formatExcelDate(loanData[k].loan_disbursedment_date);
                    const splitloanDisbursedmentDate = loanDisbursedmentDate
                        ? loanDisbursedmentDate?.split("-")
                        : null;
                    if (loanDisbursedmentDate) {
                        // console.log(`${splitloanDisbursedmentDate[2]}-${splitloanDisbursedmentDate[1]}-${splitloanDisbursedmentDate[0]}`);

                        var ldd = `${splitloanDisbursedmentDate[2]}-${splitloanDisbursedmentDate[1]}-${splitloanDisbursedmentDate[0]}`;
                    } else {
                        ldd = null;
                    }

                    const loanReleaseDate = formatExcelDate(loanData[k].loan_release_date);
                    const splitloanReleaseDate = loanReleaseDate
                        ? loanReleaseDate?.split("-")
                        : null;

                    if (loanReleaseDate) {
                        // console.log(`${splitloanReleaseDate[2]}-${splitloanReleaseDate[1]}-${splitloanReleaseDate[0]}`);
                        var lrd = `${splitloanReleaseDate[2]}-${splitloanReleaseDate[1]}-${splitloanReleaseDate[0]}`;
                    } else {
                        lrd = null;
                    }

                    const loanTenureStartDate = formatExcelDate(loanData[k].loan_tenure_start_date);
                    const splitloanTenureStartDate = loanTenureStartDate
                        ? loanTenureStartDate?.split("-")
                        : null;
                    if (loanTenureStartDate) {
                        // console.log(`${splitloanTenureStartDate[2]}-${splitloanTenureStartDate[1]}-${splitloanTenureStartDate[0]}`);
                        var ltsd = `${splitloanTenureStartDate[2]}-${splitloanTenureStartDate[1]}-${splitloanTenureStartDate[0]}`;
                    } else {
                        ltsd = null;
                    }

                    const loanEmiStartDate = formatExcelDate(loanData[k].loan_emi_start_date);
                    const splitloanEmiStartDate = loanEmiStartDate
                        ? loanEmiStartDate?.split("-")
                        : null;

                    if (loanEmiStartDate) {
                        // console.log(`${splitloanEmiStartDate[2]}-${splitloanEmiStartDate[1]}-${splitloanEmiStartDate[0]}`);
                        var lesd = `${splitloanEmiStartDate[2]}-${splitloanEmiStartDate[1]}-${splitloanEmiStartDate[0]}`;
                    } else {
                        lesd = null;
                    }

                    const loanEmiLastDate = formatExcelDate(loanData[k].loan_emi_last_date);
                    const splitloanEmiLastDate = loanEmiLastDate
                        ? loanEmiLastDate?.split("-")
                        : null;
                    if (loanEmiLastDate) {
                        // console.log(`${splitloanEmiLastDate[2]}-${splitloanEmiLastDate[1]}-${splitloanEmiLastDate[0]}`);
                        var leld = `${splitloanEmiLastDate[2]}-${splitloanEmiLastDate[1]}-${splitloanEmiLastDate[0]}`;
                    } else {
                        leld = null;
                    }

                    const loanCreatedDate = formatExcelDate(loanData[k].loan_created_date);
                    const splitloanCreatedDate = loanCreatedDate
                        ? loanCreatedDate?.split("-")
                        : null;

                    if (loanCreatedDate) {
                        // console.log(`${splitloanCreatedDate[2]}-${splitloanCreatedDate[1]}-${splitloanCreatedDate[0]}`);
                        var lcd = `${splitloanCreatedDate[2]}-${splitloanCreatedDate[1]}-${splitloanCreatedDate[0]}`;
                    } else {
                        lcd = null;
                    }

                    var loanObject = {
                        loanproduct_id: loanData[k].loanproduct_id,
                        loan_type: loanData[k].loan_type,
                        loan_mandate_id: loanData[k].loan_mandate_id,
                        loan_umrn: loanData[k].loan_umrn,
                        loan_cust_status: loanData[k].loan_cust_status,
                        loan_bank_status: loanData[k].loan_bank_status,
                        loan_schedule_id: loanData[k].loan_schedule_id,
                        loan_mandate_fail_reason: loanData[k].loan_mandate_fail_reason,
                        loan_mandate_link: loanData[k].loan_mandate_link,
                        loan_disbursedment_reference:
                            loanData[k].loan_disbursedment_reference,
                        loan_disbursedment_date: ldd,
                        loan_disbursedment_notify: loanData[k].loan_disbursedment_notify,
                        loan_auth_mode: loanData[k].loan_auth_mode,
                        nach_notify: loanData[k].nach_notify,
                        loan_esign_by: loanData[k].loan_esign_by,
                        loan_esign_link: loanData[k].loan_esign_link,
                        borrower_uniqueno: loanData[k].borrower_uniqueno,
                        loanproduct_interest_rate: loanData[k].loanproduct_interest_rate,
                        loan_principal_amt: loanData[k].loan_principal_amt,
                        loan_release_date: lrd,
                        loan_tenure_start_date: ltsd,
                        loan_pre_emi_interest: loanData[k].loan_pre_emi_interest,
                        loan_emi_start_date: lesd,
                        loan_emi_last_date: leld,
                        loan_duration: loanData[k].loan_duration,
                        loan_emi_amt: loanData[k].loan_emi_amt,
                        loan_advance_emi_number: loanData[k].loan_advance_emi_number,
                        loan_tranche_number: loanData[k].loan_tranche_number,
                        loan_tranche_arr: loanData[k].loan_tranche_arr,
                        loan_tranche_gap: loanData[k].loan_tranche_gap,
                        loan_avail_insurance: loanData[k].loan_avail_insurance,
                        loan_disbursed_amt: loanData[k].loan_disbursed_amt,
                        loan_status: loanData[k].loan_status,
                        loan_status_trail: loanData[k].loan_status_trail,
                        loan_esign_document_id: loanData[k].loan_esign_document_id,
                        loan_gaurantors: loanData[k].loan_gaurantors,
                        loan_life_ins: loanData[k].loan_life_ins,
                        loan_property_ins: loanData[k].loan_property_ins,
                        loan_comments: loanData[k].loan_comments,
                        loan_companycode: loanData[k].loan_companycode,
                        loan_branchcode: loanData[k].loan_branchcode,
                        loan_sourcecode: loanData[k].loan_sourcecode,
                        loan_created_date: lcd,
                        created_by: loanData[k].created_by,
                        loan_id: loanData[k].loan_id,
                        loan_presentation_status: loanData[k].loan_presentation_status,
                        loan_purpose: loanData[k].loan_purpose
                    };
                    loanArray.push(loanObject);
                }
                // console.log(loanArray);
                axios
                    .post(url + "/loan/bulkupload", {
                        array_data: loanArray,
                        token: token,
                        email: email,
                    })
                    .then((res) => {
                        // console.log(res);
                        if (res.data.auth === false) {
                            setOpen(false);
                            toast.error(res.data.message, {
                                style: {
                                    background: "#fab6bb",
                                    color: "red",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    borderColor: "white"
                                },
                            });
                            var report, wb;
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "LoanErrorFile.xlsx");
                                setOpen(false);
                                reset();
                            }

                            setOpen(false);
                            reset()

                        } else {
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "LoanErrorFile.xlsx");
                                setOpen(false);
                            }
                            toast.success(res.data.message);
                            setOpen(false);
                            reset()
                        }
                    })
                    .catch((err) => {
                        setOpen(false);
                        reset()
                        console.log(err);
                        toast.error(err.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                    });
            };
            if (!e?.target?.files[0]) {
                console.error("No file selected or invalid file input");
                setOpen(false);
                reset();
                toast.error("No file selected or invalid file input", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
                return;
            }
            reader?.readAsArrayBuffer(e?.target?.files[0]);
        } else if (reportType === "CoapplicantBulkUpload") {
            setOpen(true);
           // reset();
            // console.log(reportType);

            reader = new FileReader();
            var CoapplicantEntry = [];
            reader.onload = function (file) {
                if (!file) {
                    console.error("No file selected or invalid file input");
                    setOpen(false);
                    reset()
                    toast.error("No file selected or invalid file input", {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    return;
                }
                data = new Uint8Array(file.target.result);
                workbook = XLSX.read(data, { type: "array" });
                sheetName = workbook.SheetNames[0];
                worksheet = workbook.Sheets[sheetName];
                CoapplicantEntry = XLSX.utils.sheet_to_json(worksheet);
                // console.log(CoapplicantEntry);

                const CoapplicantData = CoapplicantEntry.map((val) => {
                    return {
                        coapplicant_id: val.CoapplicantId,
                        coapplicant_name: val.CoapplicantName,
                        coapplicant_dob: val.CoapplicantDOB,
                        coapplicant_gender: val.CoapplicantGender,
                        coapplicant_mobile: val.CoapplicantMobile,
                        coapplicant_email: val.CoapplicantEmail,
                        coapplicant_marital_status: val.CoapplicantMaritalStatus,
                        coapplicant_education: val.CoapplicantEducation,
                        coapplicant_residence_type: val.CoapplicantResidenceType,
                        coapplicant_residence_address: val.CoapplicantResidenceAddress,
                        coapplicant_pincode: val.CoapplicantPincode,
                        coapplicant_state: val.CoapplicantState,
                        coapplicant_city: val.CoapplicantCity,
                        coapplicant_relationship: val.CoapplicantRelationship,
                        coapplicant_fathername: val.CoapplicantFatherName,
                        coapplicant_borrower_uniqueno: val.CoapplicantBorrowerUniqueno,
                        coapplicant_loan_id: val.CoapplicantLoanId,
                        coapplicant_profession_type: val.CoapplicantProfessionType,
                        coapplicant_designation: val.CoapplicantDesignation,
                        coapplicant_business_name: val.CoapplicantBusinessName,
                        coapplicant_office_address: val.CoapplicantOfficeAddress,
                        coapplicant_total_exp: val.CoapplicantTotalExp,
                        coapplicant_monthly_income: val.CoapplicantMonthlyIncome,
                        coapplicant_nature_of_business: val.CoapplicantNatureOfBusiness,
                        coapplicant_aadharno: val.CoapplicantAadharno,
                        coapplicant_panno: val.CoapplicantPanno,
                    };
                });
                // console.log(CoapplicantData);

                var CoapplicantArray = [];
                for (var l = 0; l < CoapplicantData.length; l++) {
                    const coapplicantDob = CoapplicantData[l].coapplicant_dob;
                    const coapplicantDobsplit = coapplicantDob
                        ? coapplicantDob?.split("-")
                        : null;
                    if (coapplicantDob) {
                        // console.log(`${coapplicantDobsplit[2]}-${coapplicantDobsplit[1]}-${coapplicantDobsplit[0]}`);
                        var cdob = `${coapplicantDobsplit[2]}-${coapplicantDobsplit[1]}-${coapplicantDobsplit[0]}`;
                    } else {
                        cdob = null;
                    }

                    var CoapplicantObject = {
                        coapplicant_id: CoapplicantData[l].coapplicant_id,
                        coapplicant_name: CoapplicantData[l].coapplicant_name,
                        coapplicant_dob: cdob,
                        coapplicant_gender: CoapplicantData[l].coapplicant_gender,
                        coapplicant_mobile: CoapplicantData[l].coapplicant_mobile,
                        coapplicant_email: CoapplicantData[l].coapplicant_email,
                        coapplicant_marital_status:
                            CoapplicantData[l].coapplicant_marital_status,
                        coapplicant_education: CoapplicantData[l].coapplicant_education,
                        coapplicant_residence_type:
                            CoapplicantData[l].coapplicant_residence_type,
                        coapplicant_residence_address:
                            CoapplicantData[l].coapplicant_residence_address,
                        coapplicant_pincode: CoapplicantData[l].coapplicant_pincode,
                        coapplicant_state: CoapplicantData[l].coapplicant_state,
                        coapplicant_city: CoapplicantData[l].coapplicant_city,
                        coapplicant_relationship:
                            CoapplicantData[l].coapplicant_relationship,
                        coapplicant_fathername: CoapplicantData[l].coapplicant_fathername,
                        coapplicant_borrower_uniqueno:
                            CoapplicantData[l].coapplicant_borrower_uniqueno,
                        coapplicant_loan_id: CoapplicantData[l].coapplicant_loan_id,
                        coapplicant_profession_type:
                            CoapplicantData[l].coapplicant_profession_type,
                        coapplicant_designation: CoapplicantData[l].coapplicant_designation,
                        coapplicant_business_name:
                            CoapplicantData[l].coapplicant_business_name,
                        coapplicant_office_address:
                            CoapplicantData[l].coapplicant_office_address,
                        coapplicant_total_exp: CoapplicantData[l].coapplicant_total_exp,
                        coapplicant_monthly_income:
                            CoapplicantData[l].coapplicant_monthly_income,
                        coapplicant_nature_of_business:
                            CoapplicantData[l].coapplicant_nature_of_business,
                        coapplicant_aadharno: CoapplicantData[l].coapplicant_aadharno,
                        coapplicant_panno: CoapplicantData[l].coapplicant_panno,
                    };
                    CoapplicantArray.push(CoapplicantObject);
                }
                // console.log(CoapplicantArray);
                axios
                    .post(url + "/coapplicant/bulkupload", {
                        array_data: CoapplicantArray,
                        token: token,
                        email: email,
                    })
                    .then((res) => {
                        // console.log(res);
                        if (res.data.auth === false) {
                            toast.error(res.data.message, {
                                style: {
                                    background: "#fab6bb",
                                    color: "red",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    borderColor: "white"
                                },
                            });
                            var report, wb;
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "CoapplicantErrorFile.xlsx");
                            }

                            setOpen(false);
                            reset()

                        } else {
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "CoapplicantErrorFile.xlsx");
                            }
                            toast.success(res.data.message);

                            setOpen(false);
                            reset()

                        }
                    })
                    .catch((err) => {
                        // console.log(err);
                        setOpen(false);
                        reset();
                        toast.error(err.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                    });
            };
            if (!e?.target?.files[0]) {
                console.error("No file selected or invalid file input");
                setOpen(false);
                reset();
                toast.error("No file selected or invalid file input", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
                return;
            }
            reader?.readAsArrayBuffer(e?.target?.files[0]);
        } else if (reportType === "CollateralBulkUpload") {
            setOpen(true);
            // console.log(reportType);
         //   reset();
            reader = new FileReader();
            var CollateralEntry = [];
            reader.onload = function (file) {
                if (!file) {
                    console.error("No file selected or invalid file input");
                    setOpen(false);
                    reset()
                    toast.error("No file selected or invalid file input", {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    return;
                }
                data = new Uint8Array(file.target.result);
                workbook = XLSX.read(data, { type: "array" });
                sheetName = workbook.SheetNames[0];
                worksheet = workbook.Sheets[sheetName];
                CollateralEntry = XLSX.utils.sheet_to_json(worksheet);
                // console.log(CollateralEntry);

                const CollateralData = CollateralEntry.map((val) => {
                    return {
                        collateral_id: val.CollateralId,
                        collateral_borrower_uniqueno: val.CollateralBorrowerUniqueNo,
                        collateral_loan_id: val.CollateralLoanId,
                        collateral_type: val.CollateralType,
                        collateral_address: val.CollateralAddress,
                        collateral_state: val.CollateralState,
                        collateral_city: val.CollateralCity,
                        collateral_pincode: val.CollateralPincode,
                        collateral_property_number: val.CollateralPropertyNumber,
                        collateral_property_owner_name: val.CollateralPropertyOwnerName,
                        collateral_property_area_mtr: val.CollateralPropertyAreaMtr,
                        collateral_property_area_ft: val.CollateralPropertyAreaFt,
                    };
                });
                // console.log(CollateralData);

                var CollateralArray = [];
                for (var m = 0; m < CollateralData.length; m++) {
                    var CollateralObject = {
                        collateral_id: CollateralData[m].collateral_id,
                        collateral_borrower_uniqueno:
                            CollateralData[m].collateral_borrower_uniqueno,
                        collateral_loan_id: CollateralData[m].collateral_loan_id,
                        collateral_type: CollateralData[m].collateral_type,
                        collateral_address: CollateralData[m].collateral_address,
                        collateral_state: CollateralData[m].collateral_state,
                        collateral_city: CollateralData[m].collateral_city,
                        collateral_pincode: CollateralData[m].collateral_pincode,
                        collateral_property_number:
                            CollateralData[m].collateral_property_number,
                        collateral_property_owner_name:
                            CollateralData[m].collateral_property_owner_name,
                        collateral_property_area_mtr:
                            CollateralData[m].collateral_property_area_mtr,
                        collateral_property_area_ft:
                            CollateralData[m].collateral_property_area_ft,
                    };
                    CollateralArray.push(CollateralObject);
                }
                // console.log(CollateralArray);
                axios
                    .post(url + "/collateral/bulkupload", {
                        array_data: CollateralArray,
                        token: token,
                        email: email,
                    })
                    .then((res) => {
                        // console.log(res);
                        if (res.data.auth === false) {
                            toast.error(res.data.message, {
                                style: {
                                    background: "#fab6bb",
                                    color: "red",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    borderColor: "white"
                                },
                            });
                            var report, wb;
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "CollateralErrorFile.xlsx");
                            }

                            setOpen(false);
                            reset()

                        } else {
                            // console.log(res.data.errorMessage.length);
                            if (res.data.errorMessage.length !== 0) {
                                report = XLSX.utils.json_to_sheet(res.data.errorMessage);
                                wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, report, "Sample");
                                XLSX.writeFile(wb, "CollateralErrorFile.xlsx");
                            }

                            toast.success(res.data.message);

                            setOpen(false);
                            reset()

                        }
                    })
                    .catch((err) => {
                        setOpen(false);
                        reset();
                        // console.log(err);
                        toast.error(err.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                    });
            };
            if (!e?.target?.files[0]) {
                console.error("No file selected or invalid file input");
                setOpen(false);
                reset();
                toast.error("No file selected or invalid file input", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
                return;
            }
            reader?.readAsArrayBuffer(e?.target?.files[0]);
        } else if (reportType === "ReportType") {
            toast.error("Please Select Report Type", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            setOpen(false);
            reset()

        }
    };
    const subsectorArray = [
        "CoffeeandTea",
        "EdibleOils",
        "FoodGrainsincludingmilling",
        "FruitandNuts",
        "Implements",
        "Logwood&Plywoods",
        "Spices",
        "Starches",
        "sugar",
        "Vegetables",
        "Business&IndustrialENT",
        "Hotels",
        "TravelServices(otherthanticketing)",
        "TravelServices(ticketing)",
        "Cosmetic&Toiletries",
        "Detergents",
        "Groceries",
        "Tobacco",
        "MedicalEquipment",
        "DiagnosticCenters",
        "Drugsandpharma",
        "Drugsandpharma-bulkdrugsAPI",
        "Hospitals",
        "CommercialVehicles(LCV)",
        "Cycle",
        "DealersandServiceCenters-PassengerCars",
        "DealersandServiceCenters-2W/3W",
        "AutoAncillaries",
        "BallandRollerBearing",
        "Communication&Broadcasting",
        "ElectricalEquipment/RailwayEquipment",
        "Fastners",
        "Industrialmachineries",
        "MachineTools&Electrodes",
        "OfficeEquipment",
        "Transformers&Storagebatteries",
        "Valves",
        "Weldingmachineryandrelateditems",
        "Artificialorimitationjewllery",
        "Gems&Jewellery",
        "Advertising",
        "Broadcasting",
        "CableandotherTVservices",
        "Printing",
        "FinishedMetalProductslikeBrasswares",
        "Copper",
        "Fabrication",
        "IronandSteel(Scrap)",
        "Minerals&nonferrous",
        "PracticingLawyer",
        "PaperandPaperProducts",
        "LPGCylinders+dealers",
        "PetroleumProducts(lubricants)",
        "PetroleumProducts(otherthanlubricants)",
        "Paint&Varnish",
        "PetrolPumps",
        "Photographic&AlliedProducts",
        "OtherPlasticGoods",
        "PlasticFilmsandPackaging",
        "Rubber&RubberProducts",
        "BlendedYarn",
        "ReadymadeGarments",
        "Silk",
        "AirConditioners&Refrigerators",
        "ConsumerElectronics",
        "DomesticAppliances",
        "ElectricalGoods",
        "MobilePhones&Accessories",
        "Engineering&LegalServices",
        "Education-Coaching",
        "Animal&MarineFoods",
        "Beer",
        "Bakery",
        "Dairy&Poultry",
        "MedicalSupplies",
        "Packaged/Processedfood",
        "Carbonblack/CausticSoda",
        "Fertilizers&Pesticides",
        "OtherInorganicandorganicChemicals(notcovered)",
        "Petrochemicals",
        "DyesandPigments/SpecialityChemicals",
        "Computer-Education",
        "Computers",
        "InternetServices",
        "Computer-Software",
        "Air",
        "ArchitectsandInteriorDesigning",
        "CharteredAccountant",
        "Doctors-consulting",
        "EventManagement",
        "HouseKeeping&Othermanpowerrelated",
        "PlacementandHR",
        "ITES&BPO",
        "HairSalon&BeautyTreatments",
        "TechnicalConsultancyandEngineeringServices",
        "HomeFurniture&Furnishing",
        "Handicraft",
        "Luggage",
        "Opticianandaccessories",
        "OfficeSupplies&Stationery",
        "Watches",
        "OtherBuildingMaterials",
        "CementandAsbestosProducts",
        "Constructionequipment(CEQ)",
        "Granite",
        "CeramicTiles&Sanitary-ware",
        "Packaging",
    ];

    const sectorArray = [
        "Agri Products",
        "Energy",
        "Entertainment & Leisure",
        "Finance",
        "FMCG",
        "Food & Beverages",
        "Gen Indl Services",
        "Hardware Equipment",
        "Healthcare",
        "Healthcare Providers",
        "Household Products",
        "Automobiles",
        "Industrial Equipment",
        "Institutions & Trusts",
        "Jewellery",
        "Media",
        "Metals",
        "Minning",
        "Non store Retail",
        "Others",
        "Paints",
        "Paper",
        "Broad line/Multiline",
        "Petroleum Products",
        "Photographic & Allied",
        "Plastics",
        "Professionsl Services",
        "Rubber",
        "Sevices",
        "Sevices Business",
        "Sevices Communication",
        "Sevices Transport",
        "Software",
        "Cement",
        "Speciality",
        "Textiles",
        "Transport",
        "Transport & Logistics",
        "Pharmaceuticals",
        "Electronics & Consumer Durables",
        "Engineering",
        "Education",
        "Animal Products",
        "Food and Beverages",
        "Chemicals",
        "IT and Computers",
        "Transportation Logistics",
        "Professional Services",
        "Specialty",
        "Computers",
        "Construction",
        "Containers & Packaging",
        "Durables",
    ];

    const industryArray = [
        "BROKING",
        "DEFAULT",
        "DISTRIBUTOR",
        "EDUCATION",
        "ENTERTAINMENT",
        "Fintech",
        "FRANCHISEE",
        "HFC",
        "MANUFACTURING",
        "MFI",
        "NBFC",
        "OTHERS",
        "REAL ESTATE",
        "RETAILER",
        "Services",
        "TRADING",
        "WHOLE SELLER",
    ];

    const natureOfBusinessArray = [
        "FINANCIAL INSTITUTE OTHER THAN NBFC",
        "NON-BANK FINANCIAL COMPANY",
        "FINANCIAL INTERMEDIATERIES",
        "MEDIA AND ENTERTAINMENT",
        "BANKING",
        "JEWELRY AND ORNAMENTS",
        "CHEMICALS",
        "ADVERTISING AND PROMOTION",
        "EDUCATION",
        "FREIGHT AND LOGISTICS",
        "REAL ESTATE AND BUILDER",
        "AUTOMOBILES",
        "CLOTH AND TEXTILES",
        "PHARMA AND MEDICINE",
        "ARCHITECT",
        "DOCTOR",
        "HOTEL AND HOSPITALITY",
        "IRON AND STEEL",
        "AGRICULTURE",
        "ACCOUNT CONSULTING",
        "CONTRACTOR AND FRANCHISEE",
        "ENGINEERING PRODUCTS",
        "IT AND SOFTWARE",
        "INSURANCE CIVIL CONTRACTOR",
        "TELECOM HARDWARE AND DISTRIBUTION",
        "AGRICULTURE PROCESSING",
        "BPO AND KPO",
        "CEMENT MANUFACTURING STOCKING AND ALLIED ACTI",
        "ELECTRICAL ELECTRONICS MANUFACTURING SERVICE",
        "FMCG",
        "FURNITURE AND WOOD PRODUCTS",
        "IT HARDWARE AND PERIPHERALS",
        "NATURAL RESOURCES RELATED",
        "PAPER PRODUCTS AND ALLIED ACTIVITIES",
        "PLASTICS AND ALLIED ACTIVITIES",
        "PUBLISHING AND PRINT MEDIA",
        "RETAIL SHOPS AND PROVISIONS RELATED",
        "RUBBER INDUSTRY AND ALLIED PRODUCTS",
        "SHIPPING INDUSTRY",
        "OTHERS",
    ];

    const loanStatusBulkUpload = [
        "CREATED",
        "ANALYST APPROVED",
        "ANALYST REJECTED",
        "MANAGER APPROVED",
        "MANAGER REJECTED",
        "LENDER APPROVED",
        "LENDER REJECTED",
        "ESIGN INITIATED",
        "ESIGNED",
        "ENACH INITIATED",
        "ENACH DONE",
        "RFD",
        "CANCELLED",
        "CLOSED",
        "RESTRUCTURED",
        "FORECLOSED",
        "PARTLY DISBURSED",
        "DISBURSED",
        "SETTLED",
        "CPV INITIATED",
        "CPV DONE",
        "TOPUP",
        "TOPUP + BT",
        "DROP OFF",
    ];
    return {
        open, setOpen, isOpen, setIsOpen, openView, reportType, setreportType, setBusinessNature, businessNature, setCollectionBank, CollectionBank,
        setGender, gender, setIndustry, industry, setSalaryMode, SalaryMode, setSector, sector, setSubsector, subsector, setTitle, title, setcompanytype, companytype, seteducation, education, setloanAdvanceEmi, loanAdvanceEmi, setloanAuthMode, loanAuthMode, setloanBulkType, loanBulkType,
        setloanEsignBy, loanEsignBy, setloanStatus, loanStatus, setmaritalstatus, maritalstatus, setprofessiontype, professiontype, setresidencetype, residencetype, fileInputRef, handleChange, insertDataIntoExcel, uploadFile, subsectorArray, sectorArray, industryArray, natureOfBusinessArray, loanStatusBulkUpload
    }
}
export default useBulkUpload;